import Vue from 'vue';
import _interopRequireDefault from 'babel-runtime/helpers/interopRequireDefault';

const styles = {
  container: {
    overflowY: 'scroll'
  }
};
var _vue = _interopRequireDefault(require('vue'));

export default Vue.component('VueAutoVirtualScrollList', {
  name: 'auto-virtual-scroll-list',
  props: {
    totalHeight: {
      type: Number,
      required: true
    },
    defaultHeight: {
      type: Number,
      required: true
    },
    extraItems: {
      type: Number,
      default: 1
    }
  },
  data: function () {
    return {
      offset: 0,
      // items offset
      heights: [],
      scrollTop: 0,
      numberOfItems: false
    };
  },
  methods: {
    /** Reset component (variables and scroll) */
    reset: function reset() {
      var currentScrollTop = this.scrollTop;

      this.offset = 0;
      this.heights = [];
      this.numberOfItems = false;

      this.$refs.container.scrollTop = currentScrollTop;
    },
    calculateSpaceBefore: function calculateSpaceBefore() {
      var scrollTop = this.scrollTop;
          var heights = this.heights;
          var defaultHeight = this.defaultHeight;
      var firstItemIndex = 0;
      var spaceBefore = 0; // eslint-disable-next-line no-constant-condition

      while (true) {
        var itemHeight = heights[firstItemIndex] || defaultHeight;
        if (spaceBefore + itemHeight > scrollTop) break;
        firstItemIndex += 1;
        spaceBefore += itemHeight;
      }

      this.offset = firstItemIndex; // save to use in tests

      return {
        spaceBefore: spaceBefore,
        firstItemIndex: firstItemIndex
      };
    },
    calculateItems: function calculateItems(firstItemIndex, paddingTop) {
      var _this$$slots$default = this.$slots.default;
          var defaultItems = _this$$slots$default === undefined ? [] : _this$$slots$default;
          var heights = this.heights;
          var defaultHeight = this.defaultHeight;
          var totalHeight = this.totalHeight;
          var extraItems = this.extraItems;
          var scrollTop = this.scrollTop;
      var items = [];
      var heightAcc = paddingTop;
      var lastItemIndex = firstItemIndex;

      for (; heightAcc - scrollTop < totalHeight && lastItemIndex < defaultItems.length; lastItemIndex += 1) {
        items.push(defaultItems[lastItemIndex]);
        heightAcc += heights[lastItemIndex] || defaultHeight;
      } // add extra items (from prop)

      for (var i = 0; i < extraItems; i += 1) {
        var item = defaultItems[lastItemIndex];
        if (item === undefined) break;
        items.push(item);
        lastItemIndex += 1;
        heightAcc += heights[lastItemIndex] || defaultHeight;
      }

      return {
        lastItemIndex: lastItemIndex,
        items: items
      };
    },
    calculateSpaceAfter: function calculateSpaceAfter(lastItemIndex) {
      var _this$$slots$default2 = this.$slots.default;
          var defaultItems = _this$$slots$default2 === undefined ? [] : _this$$slots$default2;
          var heights = this.heights;
          var defaultHeight = this.defaultHeight;
      return defaultItems.slice(lastItemIndex).map(function (x, i) {
        return heights[i + lastItemIndex] || defaultHeight;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    },
    readItemsHeight: function readItemsHeight() {
      var _this = this;

      var _this$$slots$default3 = this.$slots.default;
          var defaultItems = _this$$slots$default3 === undefined ? [] : _this$$slots$default3;
          var numberOfItems = this.numberOfItems; // if number of items is unknown set it

      if (!numberOfItems) this.numberOfItems = defaultItems.length; // else if number of items changed reset the component
      else if (numberOfItems !== defaultItems.length) this.reset(); // nextTick -> need to wait for the offset to be reloaded if scroll
      // changed (which happens at render)

      _vue.default.nextTick(function () {
        var htmlChildren = _this.$el.children;
        const offset = _this.offset;
        //let defaultHeight = _this.defaultHeight;
        var htmlAsArray = Array.from(htmlChildren);
        var children = htmlAsArray.slice(1, htmlAsArray.length - 1); // remove empty divs

        var newHeights = _this.heights.slice(0); // recomputing heights
        // scrollDiff is used for backward scrolling (where not all items before have known height)

        //let scrollDiff = 0;
        var hasChange = false;
        children.forEach(function (child, i) {
          var index = i + offset; // if item has been set or updated

          if (newHeights[index] !== child.offsetHeight) {
            // if item is in the space before items, update the scroll
            if (index <= offset) {
              //scrollDiff += child.offsetHeight - (newHeights[index] || defaultHeight);
            }

            newHeights[index] = child.offsetHeight;
            hasChange = true;
          }
        }); // trigger re-render

        if (hasChange) {
          //if (_this.heights[offset + 1]) _this.$refs.container.scrollTop += scrollDiff;
          _this.heights = newHeights;
        }
      });
    },
    setIndex: function setIndex(index) {
      var _this2 = this;

      var recursion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$$slots$default4 = this.$slots.default;
          var defaultItems = _this$$slots$default4 === undefined ? [] : _this$$slots$default4;
          var defaultHeight = this.defaultHeight;
          var heights = this.heights;
      var parsedIndex = index >= defaultItems.length ? defaultItems.length - 1 : index;
      var scrollTop = 1;

      for (var i = 0; i < parsedIndex; i += 1) {
        scrollTop += heights[i] || defaultHeight;
      }
      this.$refs.container.scrollTop = scrollTop;
      this.scrollTop = scrollTop;
      if (recursion) setTimeout(function () {
        return _this2.setIndex(index, false);
      }, 50);
    }
  },

  /** Sets callback to update the scrollTop variable */
  mounted: function mounted() {
    var _this3 = this;

    this.$refs.container.onscroll = function () {
      var newScroll = _this3.$refs.container.scrollTop || 0;
      if (newScroll !== _this3.scrollTop) _this3.scrollTop = newScroll;
    };

    // Inicializa la propiedad scrollTop con el valor actual del desplazamiento
    this.scrollTop = this.$refs.container.scrollTop || 0;

    this.readItemsHeight();
    this.$emit('updated');
  },

  /** Listen to change in slot items as well as to rendered children height */
  updated: function updated() {
    this.readItemsHeight();
    this.$emit('updated');
  },
  render: function render(h) {
    // eslint-disable-line no-unused-vars
    var _this$calculateSpaceB = this.calculateSpaceBefore();
        var spaceBefore = _this$calculateSpaceB.spaceBefore;
        var firstItemIndex = _this$calculateSpaceB.firstItemIndex;

    var _this$calculateItems = this.calculateItems(firstItemIndex, spaceBefore);
        var items = _this$calculateItems.items;
        var lastItemIndex = _this$calculateItems.lastItemIndex;

    var spaceAfter = this.calculateSpaceAfter(lastItemIndex);
    var totalHeight = this.totalHeight;
    return h('div', {
      ref: 'container',
      style: [styles.container, {
        height: ''.concat(totalHeight, 'px')
      }]
    }, [h('div', {
      style: {
        width: '100%',
        height: ''.concat(spaceBefore, 'px')
      }
    }), items, h('div', {
      style: {
        width: '100%',
        height: ''.concat(spaceAfter, 'px')
      }
    })]);
  },
});
